document.addEventListener("DOMContentLoaded", () => {
    // Selecteer ALLE sliders in de stappen
    const stepSliders = document.querySelectorAll(".step-products");

    stepSliders.forEach((slider) => {
        // Tel het aantal producten in DEZE specifieke slider
        const productCount = slider.querySelectorAll(".c-card-product__item").length;
        
        // Alleen pijlen tonen als er meer dan 3 producten zijn
        const showArrows = productCount > 3;

        const options = {
    type: "slide",
    perPage: 3, // Standaard (Desktop/groot scherm)
    perMove: 1,
    gap: "14px", 
    pagination: false,
    arrows: showArrows,
    drag: productCount > 3,
    breakpoints: {  
        // Tot en met 768px tonen we er 2
        768: { 
            perPage: 2,
            gap: "14px",
        },
        // Tot en met 420px tonen we er slechts 1
        420: { 
            perPage: 1,
            gap: "0px", // Bij 1 product is een gap vaak niet nodig
        } 
    },
};

        // Initialiseer Splide voor dit specifieke element
        if (window.Splide) {
            new window.Splide(slider, options).mount();
        } else {
            console.error("Splide is niet geladen in de window.");
        }
    });
});